const styles = {
  MARKDOWN: 'Markdown',
  PLAIN_TEXT: 'PlainText'
};

export default styles;
